import { useEffect, useState } from 'react';
import config from 'config';

import { MESSAGES, TIMEOUTS } from '../constants';


const useLoadingState = (isWhitelabel = false) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const controller = new AbortController();

        window.addEventListener('message', (event) => {
            const expectedOrigin = isWhitelabel ? window.location.origin : config.ringUrl;

            if (event.origin !== expectedOrigin) {
                return;
            }

            if (event.data === MESSAGES.PEOPLE_DIRECTORY_READY || event.data === MESSAGES.PEOPLE_PROFILE_READY) {
                setIsLoading(false);
            }
        }, { signal: controller.signal });

        // Fallback timeout in case postMessage never comes
        const fallbackTimeout = setTimeout(() => {
            setIsLoading(false);
        }, TIMEOUTS.LOADING_FALLBACK);

        return () => {
            controller.abort();
            clearTimeout(fallbackTimeout);
        };
    }, []);

    return { isLoading };
};

export default useLoadingState;
